// This file contains custom theme functions which are in used in the checkout process.
// Should definitely be bundled seperately and not be included in theme.js though, so changing the webpack config whenever we have time.
import { helpers } from './helpers';

export const checkout = {
    tco: $("#module-thecheckout-order"),
    kco: $("#module-klarnaofficial-checkoutklarnakco"),
    bco: $("#module-briqpayPaymentGateway-briqpaycheckout"),
    dpjco: $("#module-dpjcheckout-dpjcheckout"),
    selectors: ['.cart-overview', '.cart-detailed-totals'],
    init: () => {
        console.debug("checkout.js: init");
        if ($("#cart").length || checkout.kco.length || checkout.tco.length || checkout.bco.length) {
            $("#module-thecheckout-order, #module-klarnaofficial-checkoutklarnakco, #module-briqpayPaymentGateway-briqpaycheckout").on("click", ".promo-code-button", checkout.togglePromoCodeForm);
            checkout.kco.on("click", ".remove-from-cart, .js-decrease-product-quantity, .js-increase-product-quantity", checkout.updateProducts);
            checkout.bco.on("click", ".remove-from-cart, .js-decrease-product-quantity, .js-increase-product-quantity", checkout.updateProducts);
            $("#module-thecheckout-order, #module-klarnaofficial-checkoutklarnakco, #module-briqpayPaymentGateway-briqpaycheckout").on("click", ".checkout-redirect-button, .toggle-vat > a.in_checkout", checkout.toggleCart);
            $("#module-klarnaofficial-checkoutklarnakco, #module-briqpayPaymentGateway-briqpaycheckout").on("click", ".cart-added-vouchers a", checkout.removeActivePromoCode);
            window.addEventListener('CookiebotOnConsentReady', function (e) {
                checkout.sendTrackingEvents();
            }, false);
            //checkout.sendTrackingEvents();
            //checkout.rememberKlarnaVisit();
            //checkout.redirectCart();
            //checkout.preventBoxAddress();
            //checkout.tco.on("change", 'input[name="address1"]', checkout.preventBoxAddress);
        }
        else if (checkout.dpjco.length) {
            //checkout.sendTrackingEvents();
            window.addEventListener('CookiebotOnConsentReady', function (e) {
                checkout.sendTrackingEvents();
            }, false);
        }

        if (typeof prestashop !== 'undefined') {
            prestashop.on('updatedCart', () => {
                $.each(checkout.selectors, (i, el) => {
                    $(el).closest('.checkout-overlay').remove();
                    $(el).fadeTo(200, 1);
                });
                // console.log("Cart Updated");
            });
        }
    },
    sendTrackingEvents: () => {
        const pageHistory = helpers.pageHistory.get();
        if (pageHistory.current_page == pageHistory.previous_page) {
            return;
        }
        checkout.pushToDataLayer();
        //if (prestashop.urls.base_url != 'https://www.dpj.se/') {
            let adsId = '';
            let conversionLabel = '';
            let userTypeVat = prestashop.configuration.display_prices_tax_incl ? 'private' : 'company';
            switch (prestashop.urls.base_url) {
                case 'https://www.dpj-workspace.com/at/':
                    adsId = "AW-384198116";
                    conversionLabel = "AnDgCPrCpqkYEOTLmbcB";
                    break;
                case 'https://www.dpj-workspace.com/de/':
                    adsId = "AW-480897207";
                    conversionLabel = "X0uqCNb6l6kYELfRp-UB";
                    break;
                case 'https://www.dpj-workspace.com/dk/':
                    adsId = "AW-539799660";
                    conversionLabel = "ltAlCP_U8qMYEOzgsoEC";
                    break;
                case 'https://www.dpj-workspace.com/fi/':
                    adsId = "AW-411429675";
                    conversionLabel = "WvXQCLqwoakYEKvWl8QB";
                    break;
                case 'https://www.dpj-workspace.com/fr/':
                    adsId = "AW-10859090738";
                    conversionLabel = "JtFRCIu1uKYYELKmgroo";
                    break;
                case 'https://www.dpj-workspace.com/nl/':
                    adsId = "AW-10883698233";
                    conversionLabel = "iNEuCPma0JMYELmc4MUo";
                    break;
                case 'https://www.dpj.se/':
                    adsId = "AW-1001003807";
                    conversionLabel = "Z7RiCOm-n6kYEJ-2qN0D";
            }
            let data = {
                'send_to': adsId,
                'user_type_vat': userTypeVat,
                'value': prestashop.cart.totals.total_including_tax.amount,
                'items': []
            };
            prestashop.cart.products.forEach((product) => {
                let countrySuffix = prestashop.urls.base_url == 'https://www.dpj.se/' ? 'SE' : prestashop.urls.base_url.slice(-3).replace("/", "").toUpperCase();
                let itemId = 'DPJ' + countrySuffix + product.id_product;
                itemId = product.id_product_attribute == "0" ? itemId : itemId + "v" + product.id_product_attribute;
                data.items.push({
                    'id': itemId,
                    'google_business_vertical': 'retail'
                });
            });
            try {
            gtag('event', 'page_view', data);
            gtag('event', 'conversion', {
                'send_to': `${adsId}/${conversionLabel}`,
                'user_type_vat': userTypeVat,
                //'event_callback': callback
            });
            } catch (error) {
                console.error("checkout.js: error sending tracking events", error);
            }
            //console.log(data, {'send_to': `${adsId}/${conversionLabel}`});
        //}

        /*if (prestashop.urls.base_url == 'https://www.dpj-workspace.com/de/') {
            let data = {
                'send_to': 'AW-480897207',
                'value': prestashop.cart.totals.total_including_tax.amount,
                'items': []
            };
            prestashop.cart.products.forEach((product) => {
                let countrySuffix = prestashop.urls.base_url == 'https://www.dpj.se/' ? 'SE' : prestashop.urls.base_url.slice(-3).replace("/", "").toUpperCase();
                let itemId = 'DPJ' + countrySuffix + product.id_product;
                itemId = product.id_product_attribute == "0" ? itemId : itemId + "v" + product.id_product_attribute;
                data.items.push({
                    'id': itemId,
                    'google_business_vertical': 'retail'
                });
            });
            console.log(data);
            gtag('event', 'page_view', data);
            gtag('event', 'conversion', {
                'send_to': 'AW-480897207/X0uqCNb6l6kYELfRp-UB',
                //'event_callback': callback
            });
        }
        else {
            checkout.pushToDataLayer();
        }*/
    },
    pushToDataLayer: () => {
        var data = {
            event: "begin_checkout",
            ecommerce: {
                currency: prestashop.currency.iso_code,
                value: prestashop.cart.totals.total_including_tax.amount,
                items: []
            }
        }

        prestashop.cart.products.forEach((product) => {
            var itemData = {
                item_name: product.name, // req
                //discount: product.reduction / (1 + (product.rate / 100)),
                discount: product.reduction,
                item_brand: product.manufacturer_name,
                price: product.price_with_reduction,
                quantity: product.quantity,
            }
            var variant = "";
            Object.keys(product.attributes).forEach(function(key) {
                variant += key + ": " + product.attributes[key] + ", ";
            });
            itemData.item_variant = variant.substring(0, variant.length - 2);
            //itemData.item_id = product.id_product_attribute == "0" ? product.id_product : product.id_product + "-" + product.id_product_attribute;
            let countrySuffix = prestashop.urls.base_url == 'https://www.dpj.se/' ? 'SE' : prestashop.urls.base_url.slice(-3).replace("/", "").toUpperCase();
            let itemId = 'DPJ' + countrySuffix + product.id_product;
            itemData.item_id = product.id_product_attribute == "0" ? itemId : itemId + "v" + product.id_product_attribute;
            data.ecommerce.items.push(itemData);
        });
        //console.log(data);
        dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
        dataLayer.push(data);
    },
    toggleCart: () => {
        // Toggle VAT mode before following the link to move to another checkout page
        let success = false;
        let userType = prestashop.configuration.display_prices_tax_incl ? 'company' : 'private';
        const url = prestashop.urls.base_url + 'modules/dpjtogglevat/set-vat.php';
        $.ajax({
            url: url,
            type: "get",
            async: false,
            data: { type_of_user: userType },
            success: function (res) {
                success = true;
            }
        });
        return success;
    },
    togglePromoCodeForm: () => {
        // Toggles the input field for promo codes in the checkout
        let form = checkout.tco.length ? $("#module-thecheckout-order #promo-code form") : $(".cart-voucher form");
        if (form.hasClass("active")) {
            form.removeClass("active");
        }
        else {
            form.addClass("active");
        }
    },
    removeActivePromoCode: (e) => {
        const params = new URLSearchParams($(e.currentTarget).prop("href"));
        let token = params.get('token');
        let discountId = params.get('deleteDiscount');
        var url = `${prestashop.urls.pages.cart}?ajax_request=1&action=removeVoucher&deleteDiscount=${discountId}&token=${token}`;
        $.ajax({
            type: 'POST',
            cache: false,
            dataType: "json",
            url: url,
            complete: () => {
                window.location.reload();
            }
        });
        return false;
    },
    updateProducts: (e) => {
        // Updates the shopping cart after products have been removed or changed quantity in the checkout process
        e.preventDefault();
        const target = $(e.currentTarget);
        const url = target.attr("href");
        $.each(checkout.selectors, (i, el) => {
            var overlayDiv = $("<div class='checkout-overlay'>").css({
                'z-index': 100,
                'left': 0,
                'top': 0,
                'position': 'absolute',
                'width': '100%',
                'height': '100%'
            });
            $(el).prepend(overlayDiv)
            $(el).fadeTo(200, .25);
        });
        // console.log("post updateCart");
        $.post(url).then((res) => {
            if ($("#klarna-checkout-iframe").length) {
                window.location.reload();
            }
            prestashop.emit('updateCart', { reason: { linkAction: 'refresh' }, resp: {} });
        });
    },
    /*redirectCart: () => {
        // Redicrects visitor to correct cart depending on the current VAT mode.
        if (prestashop.urls.base_url !== 'https://www.dpj-workspace.com/es/') {
            if ($("#cart").length && prestashop.configuration.display_prices_tax_incl) {
                window.location.href = prestashop.urls.base_url + 'module/klarnaofficial/checkoutklarnakco?action=show';
            }
            else if ($("#cart").length && !prestashop.configuration.display_prices_tax_incl) {
                window.location.href = prestashop.urls.pages.order;
            }
            else if (checkout.tco.length && prestashop.configuration.display_prices_tax_incl) {
                window.location.href = prestashop.urls.base_url + 'module/klarnaofficial/checkoutklarnakco?action=show';
            }
            else if (checkout.kco.length && !prestashop.configuration.display_prices_tax_incl) {
                window.location.href = prestashop.urls.pages.order;
            }
        }
    },*/
    /*rememberKlarnaVisit: () => {
        // Remembers visits to Klarna checkout because of address bug when going from KCO to TCO
        if (checkout.kco.length) {
            var visited = localStorage.getItem('klarna_visited');
            if (!visited) {
                localStorage.setItem('klarna_visited', 'true');
            }
            //if (prestashop.cart) {
            //    localStorage.setItem('saved_cart', JSON.stringify(prestashop.cart));
            //}
        }
    },*/
    /*preventBoxAddress: () => {
        // Prevents box addresses to be entered as delivery address
        if (checkout.tco.length) {
            let input = $("#ship-to-different-address").prop("checked") ? $('form[data-address-type="delivery"] input[name="address1"]') : $('form[data-address-type="invoice"] input[name="address1"]');
            if (input.val().toLowerCase().includes("box") && !$(".box-error").length) { //change include to indexOf
                //input.addClass("-error");
                console.log("error");
                input.closest(".form-group").append('<div class="box-error error-msg">Vi kan tyvärr inte leverera varor till en boxadress! Var vänlig ange en separat leveransadress.</div>');
            }
            else {
                //input.removeClass("-error");
                $(".box-error").remove();
            }
        }
    }*/
}
